import { render, staticRenderFns } from "./CardBlok.vue?vue&type=template&id=41962667&scoped=true&"
import script from "./CardBlok.vue?vue&type=script&lang=js&"
export * from "./CardBlok.vue?vue&type=script&lang=js&"
import style0 from "./CardBlok.vue?vue&type=style&index=0&id=41962667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41962667",
  null
  
)

export default component.exports